<template>
  <GModal class="modal--discard">
    <div slot="header">
      <!-- <button type="button" class="close" aria-label="Close"><img src="/assets/img/icons/close-modal.svg" @click.prevent="close" /></button> -->

      <h2 class="modal-heading">Discard Review</h2>
    </div>

    <div slot="body">
      <p class="text">Apakah kamu ingin membatalkan review ini?</p>
    </div>

    <div slot="footer">
      <div class="group-btn">
        <div class="col-btn">
          <a href="" class="btn btn-cancel btn-minimal" @click.prevent="close">Cancel</a>
        </div>
        <div class="col-btn">
          <a href="" class="btn btn-publish" @click.prevent="discard">Discard</a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-discard',
  methods: {
    close() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'discard' });
    },
    discard() {
      this.$emit('discard');
      this.$store.commit('toggleModalGlobalState', { modalName: 'discard' });
      this.$store.dispatch('setModalSearchProduct', true);
    },
  },
};
</script>
